import React, { useEffect, useContext }from "react";
import useForm from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import ReactTable from "react-table";

// ui components
import { makeStyles } from "@material-ui/core/styles";
import TextField from '@material-ui/core/TextField';
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import SnackbarContent from "beaktShared/components/Snackbar/SnackbarContent.js";
import { noCaseSensitive } from 'beaktShared/helpers/extras';
import { SessionContext } from "beaktShared/services/session";

// services
import {MaskMoney, transformValueFormatedtoFloat, transformValueFloattoFormated, MaskOnlyNumbers, formateDate} from "beaktShared/helpers/masks";
import { UsePutApi, useGetApi } from "beaktShared/services/crudeApiService";
import { RenovacaoVigenteResumo } from "beaktMatriz/views/Credenciamento/Steps/ContratosEstabelecimento.js";
import { royaltiesCadastrados, separarContratos } from "beaktMatriz/views/Credenciamento/Steps/ContratoEstabelecimentoService.js";

// styles
import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
const useStyles = makeStyles(styles);

export default function RoyaltiesEstabelecimento({item, CallHandleVoltar, CallUpdateItem, permissoes}) {
  const { t } = useTranslation();
  const classes = useStyles();
  const session = useContext(SessionContext);

  const [notification, setNotification] = React.useState({
    show:false,
    color:'info',
    message:''
  });
  const showNotification = (message,color) => { 
      setNotification({
        show:true,
        color:color,
        message:message      
      });
      setTimeout(function() {
        setNotification({show:false});
      }, 8000);       
  };

  const { register, handleSubmit, setValue, errors } = useForm({mode: "onChange"}); 
  const [loading, setLoading] = React.useState(false);

  // BKT-1511: valores de Royalties só são informados no cadastro inicial; depois mudam apenas pelo
  // fluxo contratual (Contrato Geral) ou pelo reajuste automático da renovação anual
  const valoresBloqueados = royaltiesCadastrados(item);
  const temPermissao = !!(permissoes && permissoes.gestaoFranqueador);
  const podeCadastrar = !valoresBloqueados && temPermissao;
  // BKT-1513: o Contrato Geral é configuração obrigatória da unidade (preenchido na aba Dados do Estabelecimento)
  const contratoGeralPendente = !!item.estabelecimentoId && separarContratos(item.estabelecimentoContratos).geral === null;

  const [{list, isLoadingList, isErrorGetList}, setListAtualiza] = useGetApi("Estabelecimentos/getestabelecimentoroyaltiessetuplog/" + item.estabelecimentoId);

  useEffect(() => {    
    if(!item.estabelecimentoId)
        return;    
    if(item.percentualRoyalties !== null)
      setValue("percentualRoyalties",transformValueFloattoFormated(item.percentualRoyalties));     
    if(item.minRoyalties !== null)
      setValue("minRoyalties", transformValueFloattoFormated(item.minRoyalties));     
    if(item.maxRoyalties !== null)
      setValue("maxRoyalties", transformValueFloattoFormated(item.maxRoyalties));    
    if(item.fixoRoyalties !== null)
      setValue("fixoRoyalties", transformValueFloattoFormated(item.fixoRoyalties));
  }, [item]);

  const onSubmit = (data, e) => {   
    e.preventDefault();
    setLoading(true);  
    
    if(!item.estabelecimentoId)
    {
      showNotification(t('error_message.fill_in_the_datails_of_the_establishment'),'danger');
      setLoading(false);  
      return false;
    }

    // Sem permissão a API responde 403 (desloga); com valores já cadastrados não há alteração manual
    if(!podeCadastrar)
    {
      showNotification(t(valoresBloqueados ? 'accreditation.royalties_locked' : 'accreditation.contract_permission_required'),'danger');
      setLoading(false);
      return false;
    }

    let estabelecimento = {
      ...item,
      estabelecimentoId: item.estabelecimentoId,
      percentualRoyalties: transformValueFormatedtoFloat(data.percentualRoyalties),
      minRoyalties: transformValueFormatedtoFloat(data.minRoyalties),
      maxRoyalties:transformValueFormatedtoFloat(data.maxRoyalties),
      fixoRoyalties: transformValueFormatedtoFloat(data.fixoRoyalties)
    }

    setLoading(true);
    let endPoint = "estabelecimentos/atualizaroyalties/"
    UsePutApi(endPoint,estabelecimento.estabelecimentoId + "/" + session.id,estabelecimento).then(result=>{
      setLoading(false);
      if(result.status !== 200)
      {                                    
        showNotification(result.message,'danger');
        return false; 
      } 
      CallUpdateItem(result.data);
      showNotification(result.message,'success');
      return true;                 
    }); 

  }

  const columns = [
    {
      Header: t('label.user'),
      // BKT-1514: usuário nulo = reajuste automático (Sistema)
      id: "usuario",
      accessor: (log) => log.usuario ? log.usuario.nome : t('label.system_user'),
    },
    {
        Header: t('label.date'),
        accessor: "dataAlteracao",
        Cell: (props) => <div> {props.value?formateDate(props.value):""} </div> 
    },
    {
        Header: "% "+t('sidebar.royalties'),
        accessor: "percentualRoyalties",
    },
    {
        Header: t('sidebar.royalties')+" min",
        accessor: "minRoyalties",
        Cell: (props) => <div> {transformValueFloattoFormated(props.value?props.value:0)} </div> 
    },
    {
        Header: t('sidebar.royalties')+" max",
        accessor: "maxRoyalties",
        Cell: (props) => <div> {transformValueFloattoFormated(props.value?props.value:0)} </div> 
    },
    {
      Header: t('label.fixed_royalties'),
      accessor: "fixoRoyalties",
      Cell: (props) => <div> {transformValueFloattoFormated(props.value?props.value:0)} </div> 
    }]    
  
  return (
    <div style={{width:'100%',padding:'20px'}}>    

    <form onSubmit={handleSubmit(onSubmit)}>
    
      <GridContainer>
        <br/>
        <GridItem xs={12} sm={12} md={12}>
         <div className="subTitulo"> 
          <h6>{t('label.royalty_data')} </h6>
         </div>
        </GridItem>
        <GridItem xs={12} sm={3} md={3}>
          <FormControl fullWidth className={classes.formControl}>
            <TextField
                error={errors.percentualRoyalties?true:false}
                label={"%"+t('sidebar.royalties')}
                variant="outlined"
                disabled={!podeCadastrar}
                inputRef={register({ required: true })}
                name="percentualRoyalties"
                InputLabelProps={{shrink: true}}
                inputProps={{maxLength: 10}}      
                InputProps={{ inputComponent: MaskMoney}}
            />
            {errors.percentualRoyalties && 
            <FormHelperText className={classes.labelRootError}>
                <span>{t('label.required')} </span>
            </FormHelperText>}
          </FormControl>
        </GridItem>
        <GridItem xs={12} sm={3} md={3}>
          <FormControl fullWidth className={classes.formControl}>
          <TextField
              error={errors.minRoyalties?true:false}
              label= {t('sidebar.royalties')+" min *"}
              variant="outlined"
                disabled={!podeCadastrar}
              inputRef={register({required: true})}
              name="minRoyalties"
              InputLabelProps={{shrink: true}}
              inputProps={{maxLength: 10}}      
              InputProps={{ inputComponent: MaskMoney}}   
          />
          {errors.minRoyalties && 
          <FormHelperText className={classes.labelRootError}>
              <span>{t('label.required')} </span>
          </FormHelperText>}
          </FormControl>
      </GridItem> 
        <GridItem xs={12} sm={3} md={3}>
          <FormControl fullWidth className={classes.formControl}>
          <TextField
              error={errors.maxRoyalties?true:false}
              label={t('sidebar.royalties')+" max *"}
              variant="outlined"
                disabled={!podeCadastrar}
              inputRef={register({required: true})}
              name="maxRoyalties" 
              InputLabelProps={{shrink: true}}
              inputProps={{maxLength: 10}}      
              InputProps={{ inputComponent: MaskMoney}}  
          />
          {errors.maxRoyalties && 
          <FormHelperText className={classes.labelRootError}>
              <span>{t('label.required')}</span>
          </FormHelperText>}
          </FormControl>
      </GridItem> 
        <GridItem xs={12} sm={3} md={3}>
          <FormControl fullWidth className={classes.formControl}>
          <TextField
              error={errors.fixoRoyalties?true:false}
              label={t('label.fixed_royalties')+" *"}
              variant="outlined"
                disabled={!podeCadastrar}
              inputRef={register({required: true})}
              name="fixoRoyalties"
              InputLabelProps={{shrink: true}}      
              InputProps={{ inputComponent: MaskMoney}}  
          />
          {errors.fixoRoyalties && 
          <FormHelperText className={classes.labelRootError}>
              <span>{t('label.required')}</span>
          </FormHelperText>}
          </FormControl>
      </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          {contratoGeralPendente &&
            <SnackbarContent color="warning" message={t('accreditation.general_contract_pending')} />}
          {valoresBloqueados
            ? <SnackbarContent color="info" message={t('accreditation.royalties_locked')} />
            : !temPermissao && <SnackbarContent color="warning" message={t('accreditation.contract_permission_required')} />}
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
         <div className="subTitulo">
          <h6>{t('accreditation.renewal_contract')} </h6>
         </div>
         <RenovacaoVigenteResumo contratos={item.estabelecimentoContratos} />
        </GridItem>
      </GridContainer>
      <GridContainer>
        <br/>
        <GridItem xs={12} sm={12} md={12}>
         <div className="subTitulo">
          <h6>{t('label.royalties_change_history')} </h6>
         </div>
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <ReactTable
              loading = {isLoadingList}
              data={list}
              filterable
              defaultFilterMethod = {noCaseSensitive}
              columns={columns}
              defaultPageSize={10}
              minRows={5}
              showPaginationBottom={true}
              className="-striped -highlight"
              previousText={t('button.previous')}
              nextText={t('button.next')}
              loadingText={t('label.loading')+"..."}
              noDataText={t('information_message.no_records_found')+"!"}
              pageText={t('label.page')}
              ofText={t('label.of')}
              rowsText={t('label.rows')}
          />
        </GridItem>
      </GridContainer>  
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>  
         <center>  <br/><br/> 
         {notification.show &&
          <SnackbarContent
            message={notification.message}
            color={notification.color}
            closeNotification={() => setNotification({show:false})}
            close
          />}

          <Button onClick={() => CallHandleVoltar()}  color="transparent" >
              {t('label.return')}
          </Button>
          {podeCadastrar &&
          <Button type="submit" color="primary" disabled={loading}>
              {t('button.to_save')} 
              {loading && <div> ...{t('label.loading')} </div>}
          </Button>}
          </center>  
        </GridItem>
      </GridContainer>  
    </form>

  </div>
  );
}